export enum TaskStepTypeEnum {
  AdaptiveCard = 'adaptiveCard',
  GbgIdScan = 'gbgIdScan',
  FileDownload = 'fileDownload',
  FileUpload = 'fileUpload'
}
